import { DataExplorerIcon } from '@hcs/design-system';
import { AppConfig, AppSlugs } from '@hcs/types';

import DexpProductImage from '../../assets/product-images/data-explorer-image.png';

export const APP_CONFIG_DEXP: AppConfig = {
  name: 'Data Explorer',
  applicationKey: 'dexp',
  type: 'product',
  appSlugForEngagement: AppSlugs.DataExplorer,
  rootPath: `/dexp`,
  Icon: DataExplorerIcon,
  descriptionLong: `
        Access industry-leading, proprietary analytics for more than 100 million
        US homes, choosing from among dozens of Data Points to customize your experience
        and surface information for making informed decisions.
      `,
  descriptionShort:
    'Upload a spreadsheet of properties and then select which data points you want to add.',
  marketingUrl: 'https://www.housecanary.com/products/data-points/',
  marketingImage: DexpProductImage,
};

export const VIEW_PATHS_DEXP = {
  NEW_ANALYSIS: 'new-analysis',
  SELECT_DATA_POINTS: 'select-data-points',
  GENERATE_ANALYSIS: 'generate-analysis',
  PREVIOUS_ANALYSES: 'previous-analyses',
} as const;
